import { render } from "./ScreenLoader.vue?vue&type=template&id=7b6a2006&scoped=true"
import script from "./ScreenLoader.vue?vue&type=script&lang=js"
export * from "./ScreenLoader.vue?vue&type=script&lang=js"

import "./ScreenLoader.vue?vue&type=style&index=0&id=7b6a2006&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6a2006"]])

export default __exports__